import axios from 'axios'
import { getWithExpiry } from '@util/LocalStorage'

type ParamType = Record<string, string | number>
type BodyType = Record<string, any>

const autherizationString = (authRequired: boolean = true): string | undefined => {
    const token = getWithExpiry('token')
    return authRequired ? `Bearer ${token}` : undefined
}

const handleResponse = (response: any): any => {
    try {
        const status = parseInt(response.status, 10)
        if (status === 200 || status === 201) {
            return response.data
        }
    } catch (error) {
        console.error(error)
        throw error
    }
}

const handleError = (error: any): void => {
    const status = parseInt(error?.response?.status, 10)
    if (status === 403) {
        localStorage.removeItem('token')
        window.location.reload()
    } else {
        throw error
    }
}

export const POST = async (url: string, body: BodyType, authRequired: boolean = true): Promise<any> => {
    return axios
        .post(
            url,
            { ...body },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: autherizationString(authRequired),
                },
            }
        )
        .then((res) => {
            return handleResponse(res)
        })
        .catch((error) => {
            handleError(error)
            throw error
        })
}

export const GET = async (url: string, params: ParamType = {}, authRequired: boolean = true): Promise<any> => {
    return axios
        .get(url, {
            params,
            headers: {
                'Content-Type': 'application/json',
                Authorization: autherizationString(authRequired),
            },
        })
        .then((res) => {
            return handleResponse(res)
        })
        .catch((error) => {
            handleError(error)
            throw error
        })
}
